export const hideChatOptions = () => {
	const chatOptionsContainer = document.getElementById('chat-options');
	if(!chatOptionsContainer) return
	chatOptionsContainer.classList.add('hidden');
}
